/**
 * Right-to-left text (Utilities.ToRtl / UPersianUtils in Unity). Unity has to
 * reverse and reshape Arabic/Hebrew glyphs by hand; browsers do it natively,
 * so here we only need to detect RTL text to set `dir`, the row direction of
 * letter/word activities and the Arabic-capable font.
 */
const RTL_RE = /[֐-׿؀-ۿݐ-ݿࢠ-ࣿיִ-﷿ﹰ-﻿]/;

export function isRtl(text: string | null | undefined): boolean {
  return !!text && RTL_RE.test(text);
}

/** `dir` attribute for a text container. */
export function dirOf(text: string | null | undefined): "rtl" | "ltr" {
  return isRtl(text) ? "rtl" : "ltr";
}

export const RTL_LANGUAGES = new Set(["ar", "he", "fa", "ur"]);

/** Direction of the interface (Home, classrooms, help) in the UI language. The stage and the editor's workspace stay LTR, as in the app. */
export function uiDir(lang: string): "rtl" | "ltr" {
  return RTL_LANGUAGES.has(lang) ? "rtl" : "ltr";
}
